import { initializeGainsight } from "./utils/init-gainsight";

export const onInitService = ({ getConfig, setContext }) => {
  const gainSightEnabled = getConfig("one.gainsight.enabled", false);
  if (gainSightEnabled) initializeGainsight();
};
